import { useQuery } from "@tanstack/react-query";
import { http } from "@/lib/data";

export const pct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(2)}%`);
export const tone = (v) => (v == null ? "text-slate-400" : v >= 0 ? "text-emerald-600" : "text-red-500");
export const num = (v, d = 2) => (v == null ? "—" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: d, minimumFractionDigits: d }));
export const shortCat = (c = "") => c.replace(/ Fund$/, "");
export const navDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");

const get = (url) => () => http.get(url).then((r) => r.data);

export const useMfMeta = () => useQuery({ queryKey: ["mf-meta"], queryFn: get("/mf/meta"), refetchInterval: (q) => (q.state.data?.returns_ready ? 600000 : 10000), retry: 5 });
export const useTicker = () => useQuery({ queryKey: ["ticker"], queryFn: get("/market/ticker"), refetchInterval: 60000 });
export const useBrokers = () => useQuery({ queryKey: ["brokers"], queryFn: get("/brokers") });
export const usePlatforms = (segment, enabled = true) => useQuery({ queryKey: ["platforms", segment], queryFn: get(`/platforms?segment=${segment}`), enabled: enabled && !!segment });
export const useInsurers = () => useQuery({ queryKey: ["insurers"], queryFn: get("/insurers") });
export const useMfTop = () => useQuery({ queryKey: ["mf-top"], queryFn: get("/mf/top?per=5"), retry: 5, retryDelay: 4000 });
